import React from 'react';
import { connect } from 'redux-bundler-react';
import { SidebarButton } from '../../application-controls/index';

class RotateNorthButton extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    const { doSetRotationNorth } = this.props;
    doSetRotationNorth();
  }

  render() {
    const { viewState } = this.props;
    const { rotation } = viewState;
    const style = {
      display: 'inline-block',
      transform: 'rotate(' + Math.round(rotation) + 'deg)'
    }
    return (
      <SidebarButton
        iconClass="mdi mdi-navigation"
        iconStyle={ style }
        label="Rotate North"
        title="Rotate North"
        onClick={ this.handleClick }
      />
    );
  }
}

export default connect(
  'doSetRotationNorth',
  'selectViewState',
  RotateNorthButton
);